import api from './api'

export interface DispatchSession {
  _id: string
  contract_id: string
  contract_ids: string
  session_ids: string
  patient_id: {
    _id: string
    firstName: string
    lastName: string
    email: string
    city?: string
    state?: string
    latitude?: number
    longitude?: number
    phone?: string
    profilePhotoUrl?: string
  }
  therapist_id?: string
  session_date: string
  session_slot: string
  duration_mins: number
  status: string
  specialization: string
  session_amount: number
  payment_method: string
  session_type?: string
}

export interface DispatchProvider {
  _id: string
  firstName: string
  lastName: string
  email: string
  specialization: { _id: string; name: string }[]
  status: string
  profilePhotoUrl: string | null
  sessions: DispatchSession[]
}

export interface DispatchProvidersParams {
  page: number
  limit: number
  search?: string
  provider_ids?: string
  session_date?: string
  end_date?: string
  status?: string
}

export interface DispatchProvidersResponse {
  totalProviders: number
  scheduledSession: number
  providers: DispatchProvider[]
}

export const getDispatchProviders = async (
  params: DispatchProvidersParams
): Promise<DispatchProvidersResponse> => {
  const response = await api.get('/schedule-session/providers', { params })
  return response.data
}

export const exportProvidersCSV = async (
  params: Omit<DispatchProvidersParams, 'page' | 'limit'>
): Promise<Blob> => {
  const response = await api.get<Blob>('/schedule-session/providers-export', {
    params,
    responseType: 'blob',
  })
  return response.data
}

export interface TodaySession {
  _id: string
  contract_id: string
  contract_ids: string
  session_ids: string
  patient_id: {
    _id: string
    firstName: string
    lastName: string
    email: string
    latitude?: number
    longitude?: number
    phone?: string
    profilePhotoUrl?: string
  }
  therapist_id: {
    _id: string
    firstName: string
    lastName: string
    email: string
    latitude?: number
    longitude?: number
    profilePhotoUrl?: string
  }
  service_id: {
    _id: string
    name: string
  }
  session_date: string
  session_slot: string
  duration_mins: number
  status: string
  specialization: string
  session_amount: number
  payment_method: string
}

export interface TodayVisitRouteResponse {
  totalSessions: number
  totalDistance: string
  driveTime: string
  totalWork: string
  sessions: TodaySession[]
}

export const getTodayVisitRoute = async (
  therapistId: string
): Promise<TodayVisitRouteResponse> => {
  const response = await api.get('/schedule-session/today-sessions', {
    params: { therapistId },
  })
  return response.data
}
